import PageHero from "../../components/public/PageHero";
import Seo from "../../components/public/Seo";
import { Target, Eye, LayoutGrid, BadgeDollarSign, UserCheck, ShieldCheck } from "lucide-react";
import PropertyImg4 from "../../assets/images/property-4.jpg";
import "./About.css";

const WHY_ITEMS = [
  {
    icon: LayoutGrid,
    text: "Comprehensive Real Estate Solutions to Fulfill Your Desires",
  },
  {
    icon: BadgeDollarSign,
    text: "Affordable Services Without Compromising Quality",
  },
  {
    icon: UserCheck,
    text: "Personalized Guidance from Dedicated Real Estate Consultants",
  },
  {
    icon: ShieldCheck,
    text: "Commitment to Protecting Your Private Data",
  },
];

function About() {
  return (
    <div className="about-page">

      <Seo
        title="About Us | All Home Desire"
        description="All Home Desire is a real estate platform for property deals, interior design and expert guidance across India."
        path="/about-us"
      />
      <PageHero
        title="About Us"
        subtitle="A real estate platform built to make buying, selling and renting transparent and effortless."
        crumbs={[{ label: "About Us" }]}
      />

      <section className="about-page__section">
        <div className="about-page__container">
          <div className="about-page__story">
            <div className="about-page__story-image">
              <img src={PropertyImg4} alt="About All Home Desire" />
              <div className="about-page__story-image-accent" />
            </div>
            <div className="about-page__story-content">
              <span className="about-page__section-label">Our Story</span>
              <h2 className="about-page__section-title">
                All Home <em>Desire</em>
              </h2>
              <div className="about-page__story-body">
                <p>
                  All Home Desire is a reputable real estate platform that
                  specializes in providing customers the latest construction and
                  property deal information in India. We also offer satisfying
                  interior design services at reasonable costs.
                </p>
                <p>
                  Our well-equipped properties are surrounded by international
                  schools, convenient transportation, shopping centers, and
                  gardens, catering to all your needs. We assist with property
                  research, loans, investments, and EMI calculations.
                </p>
                <p>
                  Whether you're buying, selling, or renting, our comprehensive
                  real estate platform and expert team ensure a seamless
                  experience in India.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-page__section about-page__section--alt">
        <div className="about-page__container">
          <div className="about-page__mv-grid">

            <div className="about-page__mv-card">
              <div className="about-page__mv-card-accent" />
              <div className="about-page__mv-icon">
                <Target size={20} />
              </div>
              <div>
                <h2 className="about-page__mv-title">Mission</h2>
                <p className="about-page__mv-text">
                  Our mission is to guide you to real estate success by exceeding
                  expectations and delivering exceptional service, turning your
                  dream property into a happy reality.
                </p>
              </div>
            </div>

            <div className="about-page__mv-card">
              <div className="about-page__mv-card-accent" />
              <div className="about-page__mv-icon">
                <Eye size={20} />
              </div>
              <div>
                <h2 className="about-page__mv-title">Vision</h2>
                <p className="about-page__mv-text">
                  Empowering dream homes globally — making quality real estate
                  accessible, transparent, and effortless for every family.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      <section className="about-page__section">
        <div className="about-page__container">
          <div className="about-page__why-header">
            <span className="about-page__section-label">Our Strengths</span>
            <h2 className="about-page__section-title">Why Choose Us?</h2>
          </div>
          <div className="about-page__why-grid">
            {WHY_ITEMS.map(({ icon: Icon, text }, i) => (
              <div key={i} className="about-page__why-item">
                <span className="about-page__why-number">0{i + 1}</span>
                <div className="about-page__why-icon">
                  <Icon size={20} />
                </div>
                <p className="about-page__why-text">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}

export default About;